export { default } from './AvatarCore';
export type { AvatarCoreProps } from './AvatarCore';
